
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { Option, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Color_IColor, Size_ISize } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { singleton, ofArray, iterate } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { successNotification } from "./Notifications.js";
import { Msg } from "../Model/ModelType.js";

export const Constants_longestPlainMessage = 150;

export const Constants_maxBlockHeight = "16em";

export const Constants_copiedNotificationMs = 3000;

function isShort(text) {
    if (text.length <= Constants_longestPlainMessage) {
        return !(text.indexOf("\n") >= 0);
    }
    else {
        return false;
    }
}

/**
 * One error message, as text the user can read and - when it is long enough to be worth it - copy.
 * 
 * The block preserves the line breaks the message was written with, which is the half of this that
 * is not about copying at all: `InternalError` puts a stack trace in the message, and `str` inside
 * a `div` rendered the whole of it as one line.
 */
export function errorMessage(dispatch, text) {
    let props;
    if (isShort(text)) {
        return text;
    }
    else {
        const children_2 = [(props = [["style", {
            whiteSpace: "pre-wrap",
            userSelect: "text",
            background: "#f5f5f5",
            border: "1px solid #dbdbdb",
            borderRadius: "4px",
            padding: "8px",
            marginBottom: "8px",
            maxHeight: Constants_maxBlockHeight,
            overflowY: "auto",
        }]], react.createElement("div", keyValueList(props, 1), text)), button(ofArray([new Option(/* Size */ 1, [Size_ISize.IsSmall]), new Option(/* Color */ 0, [Color_IColor.IsInfo]), new Option(/* OnClick */ 18, [(_arg) => {
            window.issieBridge.clipboardWrite(text);
            iterate(dispatch, ofArray([new Msg(/* SetSimulationNotification */ 76, [(dispatch_1) => successNotification("Error message copied - please paste it into your bug report", Msg.CloseSimulationNotification, dispatch_1)]), new Msg(/* DispatchDelayed */ 42, [[Constants_copiedNotificationMs, Msg.CloseSimulationNotification]])]));
        }])]), singleton("Copy error message"))];
        return react.createElement("div", {}, ...children_2);
    }
}

